/*==========================================================
HOMEPAGE RESPONSIVE SCRIPTS
==========================================================*/

$(function() {
    if ($('#uber').hasClass('homepage')) {
        if ($().matchHeight) {
            $('.matchHeight').matchHeight();
        }
    }

     //events carousel
     $('.homeBannerCarousel__inner').flickity({
        adaptiveHeight: false,
        autoPlay: 5000,
        cellAlign: 'left',
        contain: true,
        draggable: true,
        pageDots: true,
        prevNextButtons: false,
        pauseAutoPlayOnHover: true,
        setGallerySize: true,
        wrapAround: true,
        on: {
            ready: function() {
                // Add pause button
                var pause = '<button class="flickity-button pause" type="button"><span class="ic-sr-only">Pause Banner</span></button>';
                $(pause).insertAfter('.homeBannerCarousel__inner .flickity-page-dots');

                $('.homeBannerCarousel__inner .flickity-page-dots .dot').each(function(index){
                    $(this).attr('aria-label', 'Banner ' + (index + 1) );
                });
            }
        }
    });

    $('.homeBannerCarousel__inner .flickity-button.pause').on('click', function() {
        if ($(this).hasClass('paused')) {
            $('.homeBannerCarousel__inner .flickity-button.pause span').text('Pause Banner');
            $('.homeBannerCarousel__inner').flickity('playPlayer');
        } else {
            $('.homeBannerCarousel__inner .flickity-button.pause span').text('Play Banner');
            $('.homeBannerCarousel__inner').flickity('stopPlayer');
        }
        $(this).toggleClass('paused');
    });

    if (!window.matchMedia('(min-width: 1200px').matches) {
        $('.homeBannerCarousel__inner').flickity('stopPlayer');
    }

    //story features carousel
    $('.storyFeature__inner').flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: false,
        pageDots: true,
        on: {
            ready: function() {
                $('.storyFeature__inner .flickity-page-dots .dot').each(function(index){
                    $(this).attr('aria-label', 'Story Slide ' + (index + 1) );
                });
            }
        }
    });

    // Social previous
    $('.socialMedia .flickity-button.previous').on( 'click', function() {
        $('.SMDropdownInner').flickity('previous');
    });
     // Social next
    $('.socialMedia .flickity-button.next').on( 'click', function() {
     $('.SMDropdownInner').flickity('next');
    });

    //video carousel
    $('.videoSlider__inner').flickity({
        cellSelector: '.videoSlider__item',
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: false,
        on: {
            ready: function() {
                $('.videoSlider__inner .flickity-page-dots .dot').each(function(index){
                    $(this).attr('aria-label', 'Video Slide ' + (index + 1) );
                });
            }
        }
    });
});

function initialiseSocialFeedSlider() {
    //social carousel
    $('.SMDropdownInner').flickity({
        cellAlign: 'left',
        cellSelector: '.socialMedia__feed__item',
        groupCells: true,
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        imagesLoaded: true,
        on: {
            ready: function () {
                $('.SMDropdownInner .flickity-viewport').css('height', 'auto');
            }
        }
    });
}

$(function() {
    if ( $('.SMDropdownInner').length ) {
        initialiseSocialFeedSlider();
    }
});


$(function() {
	/*==========================================================
        Edsby MODAL
    ==========================================================*/

    $('[data-modal-id="edsbyModal"]').on('click', function (event) {
        event.preventDefault();
        $('#edsbyModal').slideDown(240).addClass('open');
        $('.modal-cover').fadeIn();
		$('body').addClass('modal-open');
        trap_focus($('#edsbyModal'), 'edsbyModal');
        $('.modal-box .close').focus();
        return false;
    });

    function closeEdsbyModal(e) {
        if ($('#edsbyModal').hasClass('open')) {
            e.stopPropagation();
            $('#edsbyModal').slideUp(240).removeClass('open');
            $('.modal-cover').fadeOut();
            $('body').removeClass('modal-open');
            remove_trap_focus($('#edsbyModal'), 'edsbyModal');
            $('.edsbyFeed').focus;
        }
    }

    $('#edsbyModal .close, .modal-cover').on('click', function (e) {
        closeEdsbyModal(e);
        return false;
    });

    $('#edsbyModal .close, .modal-close').on('keydown', function (e) {
        var code = e.keyCode || e.which;
        if (code === 13) { //Enter keycode
            closeEdsbyModal(e);
        }
        return false;
    });

    // Add events to Flickity prototype
    ['play', 'stop', 'pause', 'unpause'].forEach(function(action) {
        var methodName = action + 'Player';
        Flickity.prototype[methodName] = function() {
            this.player[action]();
            this.dispatchEvent(methodName);
        };
    });
});
